import { z } from 'zod';
import { fleetRecoveryIdSchema, fleetRecoveryUuidSchema } from '../fleetRecoverySchemas';
import { recoveryGenerationV3Schema } from './contracts';

/** Names retained completed evidence; channel, artifact identities and outcome
 * come exclusively from the server's original immutable operation. */
export const recoveryHistoricalInstalledBindingRequestV1Schema = z.object({ schemaVersion: z.literal(1),
  operationId: fleetRecoveryUuidSchema, generation: recoveryGenerationV3Schema, bootId: fleetRecoveryIdSchema }).strict();
export type RecoveryHistoricalInstalledBindingRequestV1 = z.infer<typeof recoveryHistoricalInstalledBindingRequestV1Schema>;
export const RECOVERY_PRODUCT_INSTALL_KINDS = ['install', 'upgrade', 'force-upgrade', 'repair', 'rebuild-product'] as const;
export const RECOVERY_PRODUCT_MUTATION_KINDS: readonly string[] = [...RECOVERY_PRODUCT_INSTALL_KINDS, 'uninstall-product', 'decommission'];
